import Repository from '@/repositories/RepositoryFactory';
import ApiState from "../../enums/APISTATE";

const groupTemplateRepository = Repository.get('groupTemplateRepository');

export default ({
    namespaced: true,
    state: {
      groupTemplate: {},
      groupTemplateApiState: ApiState.INIT,
      groupTemplates: [],
      historicGroupTemplatesDisplayed: [],
      groupTemplatesApiState: ApiState.INIT,
      simulating: false,
      showAll: false
    },
    mutations: {
      setGroupTemplateApiState: (state, apiState) => {
        state.groupTemplateApiState = apiState;
      },
      setGroupTemplate(state, response) {
        const { data } = response;
        state.groupTemplate = data;
        state.groupTemplateApiState = ApiState.LOADED;
      },
      setGroupTemplatesApiState: (state, apiState) => {
        state.groupTemplatesApiState = apiState;
      },
      setGroupTemplates(state, response) {
        const { data } = response;
        state.groupTemplates = data;
        state.groupTemplatesApiState = ApiState.LOADED;
      },
      initialized(state, { groupTemplate, groupTemplates }) {
        state.groupTemplate = groupTemplate;
        state.groupTemplates = groupTemplates;
      },
      setSimulating(state, simulating) {
        state.simulating = simulating;
      },
      setShowAll(state, showAll){
        state.showAll = showAll;
      },
      setHistoricGroupTemplatesDisplayed(state, historicGroupTemplate){
        state.historicGroupTemplatesDisplayed = historicGroupTemplate
      }
    },
    actions: {
      async getAllTemplatesForGroup({ commit, dispatch }, forGroup) {
        commit('setGroupTemplatesApiState', ApiState.LOADING);
        try {
          commit('setGroupTemplates', await groupTemplateRepository.getAllForGroup(forGroup));
          dispatch('setHistoricGroupTemplatesDisplayed');
        }
        catch (error) {
          console.error(error);
          commit('setGroupTemplatesApiState', ApiState.ERROR);
        }
      },
      async updateGroupTemplate({ commit, dispatch, state }, dto) {
        commit('setGroupTemplateApiState', ApiState.LOADING);
        try {
          const groupTemplate = await groupTemplateRepository.update(dto);
          commit("setGroupTemplate", groupTemplate)
        }
        catch (error) {
          console.error(error);
          commit('setGroupTemplateApiState', ApiState.ERROR);
        }
      },
      async createGroupTemplate({ commit, dispatch, state }, dto) {
        commit('setGroupTemplateApiState', ApiState.LOADING);
        try {
          const groupTemplate = await groupTemplateRepository.create(dto);
          commit("setGroupTemplate", groupTemplate)
        }
        catch (error) {
          console.error(error);
          commit('setGroupTemplateApiState', ApiState.ERROR);
        }
      },
      async applyGroupTemplate({ commit, dispatch, state }, dto) {
        commit('setGroupTemplateApiState', ApiState.LOADING);
        try {
          const groupTemplate = await groupTemplateRepository.apply(dto);
          commit("setGroupTemplate", groupTemplate)
        }
        catch (error) {
          console.error(error);
          commit('setGroupTemplateApiState', ApiState.ERROR);
        }
      },
      async canApplyGroupTemplate({ commit, dispatch, state }, dto) {
        const result =  await groupTemplateRepository.canApply(dto);
        return result.data;
      },
      async setHistoricGroupTemplatesDisplayed({commit, state}){
        const groupTemplates = state.showAll ? state.groupTemplates.filter(q => q.state === 10) : state.groupTemplates.filter(q => q.state === 10).slice(0,1);
        commit("setHistoricGroupTemplatesDisplayed", groupTemplates )
      },
      async showAllPressed({commit,state, dispatch}){
        commit("setShowAll", !state.showAll);
        dispatch("setHistoricGroupTemplatesDisplayed");
      },
      setSimulating({commit}, isSimulating) {
        commit('setSimulating', isSimulating);
      },
      async rollbackGroupTemplate({ commit, dispatch, state }, dto) {
        commit('setGroupTemplateApiState', ApiState.LOADING);
        try {
          const groupTemplate = await groupTemplateRepository.rollbackGroupTemplate(dto);
          commit('setGroupTemplateApiState', ApiState.LOADED);
        }
        catch (error) {
          console.error(error);
          commit('setGroupTemplateApiState', ApiState.ERROR);
        }
      },
    },
    getters: {
      groupTemplatesApiState(state) {
        return state.groupTemplatesApiState;
      },
      groupTemplates(state) {
        return state.groupTemplates;
      },
      groupTemplateApiState(state) {
        return state.groupTemplateApiState;
      },
      groupTemplate(state) {
        return state.groupTemplate;
      },
      isGroupTemplateSimulating(state) {
        return state.simulating;
      },
      historicGroupTemplatesDisplayed: (state) => {return state.historicGroupTemplatesDisplayed},
      showAll: (state) => {return state.showAll}
    }
  });